export const REQUIRED_RULE = { message: '"${label}" is required', required: true };
